var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Calendário ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Calendário*",
      "outlined": "",
      "dense": "",
      "counter": "100",
      "maxlength": "100",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Ano Calendário*",
      "item-text": "ano",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.$anosCalendarioAntesDepois(),
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.anoCalendario,
      callback: function ($$v) {
        _vm.$set(_vm.content, "anoCalendario", $$v);
      },
      expression: "content.anoCalendario"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Período do Calendário",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.periodo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "periodo", $$v);
      },
      expression: "content.periodo"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3 align-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', {
    attrs: {
      "true-value": true,
      "false-value": false,
      "label": "Tornar Calendário Vigente",
      "inset": "",
      "color": "primary",
      "dense": ""
    },
    model: {
      value: _vm.content.vigente,
      callback: function ($$v) {
        _vm.$set(_vm.content, "vigente", $$v);
      },
      expression: "content.vigente"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  })], 1)], 1)], 1), _c('sca-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Editar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }